import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "@mui/material";
import Spinner from "features/spinner/Spinner";
import { toast } from "react-toastify";
import { useUploadMediaMutation } from "app/api/media";
import { useChecklistContext } from "context/ChecklistContext";

type Props = {
  onCloseModal: () => void;
};

const UploadFile: React.FC<Props> = ({ onCloseModal }) => {
  const { checklist } = useChecklistContext();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadMedia, { isLoading: fileIsLoading }] = useUploadMediaMutation();

  const handleModalClose = () => {
    onCloseModal();
  };

  const handleFileChange = (event) => {
    // Update the state with the selected file
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (!checklist || !selectedFile) return;

    // Determine if image or video
    uploadMedia({
      file: selectedFile!,
      checklistId: checklist?.id,
    })
      .unwrap()
      .then(() => {
        // Success handling
        toast.success("Filen har laddats upp!", {
          autoClose: 3000,
          hideProgressBar: true,
        });
        handleModalClose();
      })
      .catch(() => {
        // Error handling
        toast.error("Någonting gick fel när filen skulle laddas upp.", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };

  return (
    <>
      <Modal show={true} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Ladda upp bild eller film</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {fileIsLoading ? (
            <div className="d-flex flex-column align-items-center justify-content-center my-3">
              <Spinner size="3rem" color="#5f5f5f" className="mb-3" />
              <p>Vänta medan filen laddas upp</p>
            </div>
          ) : (
            <>
              <input type="file" onChange={handleFileChange} />
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="contained" color="error" className="me-2" onClick={handleModalClose}>
            Avbryt
          </Button>

          <Button variant="contained" onClick={handleUpload} disabled={selectedFile === null}>
            Ladda upp
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UploadFile;
